export default function getLicenseStatusLabel(licenseStatus) {
    let label;

    switch (licenseStatus) {
        case 'LICENSE_USED':
            label = 'Used';
            break;
        case 'LICENSE_ASSIGNED':
            label = 'Assigned';
            break;
        case 'LICENSE_UNASSIGNED':
            label = 'Unassigned';
            break;
        case 'LICENSE_CANCELLED':
            label = 'Cancelled';
            break;
        case 'LICENSE_ACTIVE':
            label = 'Active';
            break;
        case 'LICENSE_WATCHING':
            label = 'Watching';
            break;
        default:
            label = 'Unknown';
            break;
    }

    return label;
}